import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';

import { AngleRightIcon } from '../../../../../../components/icon/solid';
import styles from './styles';

type Props = {
  onClick: () => void;
};

const NextAction = ({ onClick }: Props) => {
  const classes = styles();

  return (
    <Tooltip
      title="Next"
      PopperProps={{
        disablePortal: true,
      }}
    >
      <IconButton onClick={onClick} className={classes.button}>
        <AngleRightIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  );
};

export default NextAction;
